module.exports = __webpack_public_path__ + "img/PrinterConnected.482f69ae.svg";